import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useToastMessages } from '../../../../../hooks/useToastMessages.jsx';
import { routes } from '../../../../../utils/helpers/ApiClient.jsx';
import { useNavigate } from 'react-router-dom';
import { useSaveExternalPartnerMutation } from '../../../../../redux/services/externalPartners.jsx';
import ExternalPartnersForm from '../../../../common/External/ExternalPartnersForm.jsx';
import { MainTitle } from '../../../../common/index.jsx';

const ExternalPartnerRegistrationPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { successMessage, apiErrorMessage, errorMessage } = useToastMessages();

  const [
    saveExternalPartner,
    {
      data: saveResponse,
      isSuccess: saveExternalPartnerSuccess,
      isError: saveExternalPartnerError,
      error: saveError,
    },
  ] = useSaveExternalPartnerMutation();

  useEffect(() => {
    document.title = t('Registrácia externého partnera FRI');
  }, []); // Runs on mount

  const handleSaveExternalPartner = (values) => {
    saveExternalPartner({
      body: {
        ...values,
      },
    });
  };

  useEffect(() => {
    if (!saveExternalPartnerSuccess) return;

    // Some APIs return 200 with logical error { success: false, message: '...' }
    if (
      saveResponse &&
      typeof saveResponse === 'object' &&
      saveResponse.success === false
    ) {
      errorMessage({
        message: t('Uloženie zlyhalo'),
        description: saveResponse.message || t('Nastala neočakávaná chyba.'),
      });
      return; // don't navigate on failure
    }

    // Happy path
    successMessage({
      message: t('Ďakujeme za registráciu!'),
      description: t(
        'Vašu žiadosť o registráciu sme zaznamenali. Po jej schválení Vám umožníme prístup do systému.',
      ),
    });
    navigate(routes.friJobsList);
  }, [saveExternalPartnerSuccess, saveResponse]);

  // Show backend error (e.g., duplicate partner name) as toast on HTTP error status
  useEffect(() => {
    if (saveExternalPartnerError && saveError) {
      apiErrorMessage(saveError);
    }
  }, [saveExternalPartnerError, saveError]);

  return (
    <>
      <MainTitle
        title={t('Registrácia externého partnera FRI')}
        backAction={true}
      />
      <div style={{ marginTop: '10px' }}>
        <ExternalPartnersForm
          isCreate={true}
          onSubmit={(values) => handleSaveExternalPartner(values)}
          initials={{
            from: 'public-ext-partner-registration',
          }}
        />
      </div>
    </>
  );
};

export default ExternalPartnerRegistrationPage;
